import './p-g1JgJ7wn.js';

/**
 * Transforms a scoped web component tag name to its unscoped version
 * by removing any version suffix (e.g., -3-4-6).
 *
 * @param {string} tagName - The (possibly) scoped tag name (e.g., "cosmos-input", "cosmos-action-menu-item-3-4-6")
 * @returns {string} The unscoped tag name (e.g., "cosmos-input", "cosmos-action-menu-item")
 */
function unscopeTagName(tagName) {
    {
        // If not in a scoped environment, return the tag name as is
        return tagName;
    }
}

export { unscopeTagName as u };
